import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SortControl } from '../../components/lister/SortControl';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { makeGetUrlQueryInformationState } from '../../redux/url/selectors/UrlSelectors';
export const SortContainer = ({ sortConfiguration }) => {
    const queryInformation = useSelector(makeGetUrlQueryInformationState());
    const dispatch = useDispatch();
    const getCurrentOrderItem = () => {
        const currentOrder = queryInformation.sort || sortConfiguration.defaultValue;
        const foundItem = sortConfiguration.properties.find(orderItem => orderItem.key === currentOrder);
        if (foundItem)
            return foundItem;
        return sortConfiguration.properties[0];
    };
    const [currentOrderItem, setCurrentOrderItem] = useState(getCurrentOrderItem);
    useEffect(() => {
        setCurrentOrderItem(getCurrentOrderItem);
    }, [sortConfiguration.properties, queryInformation.sort]);
    const updateSort = (newOrder) => dispatch(urlActions.updateSort(newOrder));
    return (_jsx(SortControl, { orderItems: sortConfiguration.properties, currentOrderItem: currentOrderItem, onOrderChange: updateSort }));
};
